import { render } from "./HistoricoCampeonatosView.vue?vue&type=template&id=2590ed58&scoped=true"
import script from "./HistoricoCampeonatosView.vue?vue&type=script&lang=js"
export * from "./HistoricoCampeonatosView.vue?vue&type=script&lang=js"

import "./HistoricoCampeonatosView.vue?vue&type=style&index=0&id=2590ed58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2590ed58"]])

export default __exports__